import type { CSSProperties } from 'preact'

import { uiTokens } from '#src/assets/ui/shared/styles.ts'

export const primaryButtonStyle: CSSProperties = {
  background: uiTokens.colors.buttonDark,
  border: 'none',
  borderRadius: uiTokens.radius.sm,
  color: uiTokens.colors.white,
  fontSize: '0.9em',
  fontWeight: '600',
  minHeight: '44px',
  padding: '0.75em 1.25em',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  whiteSpace: 'nowrap',
}

export const secondaryButtonStyle: CSSProperties = {
  background: uiTokens.colors.gray100,
  border: 'none',
  borderRadius: uiTokens.radius.sm,
  color: uiTokens.colors.gray900,
  fontSize: '0.9em',
  fontWeight: '600',
  minHeight: '44px',
  padding: '0.75em 1.25em',
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  whiteSpace: 'nowrap',
}

export const closeIconButtonStyle: CSSProperties = {
  background: uiTokens.colors.gray100,
  border: 'none',
  borderRadius: uiTokens.radius.sm,
  color: uiTokens.colors.gray900,
  width: '36px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  fontSize: '1.25rem',
  lineHeight: 1,
  flexShrink: 0,
}

export const outlineButtonStyle: CSSProperties = {
  background: uiTokens.colors.white,
  border: '1px solid #000',
  borderRadius: uiTokens.radius.sm,
  color: '#000',
  fontSize: '0.9em',
  fontWeight: '600',
  minHeight: '44px',
  padding: '0.75em 1.5em',
  textAlign: 'center',
  cursor: 'pointer',
  width: '100%',
  transition: 'background-color 0.15s ease',
}
